import React, { ReactNode } from 'react';
import { useStyles } from './Breadcrumb.styles';
import { Breadcrumbs } from '@material-ui/core';
import Link from '../Link/Link';

type BreadcrumbLink = {
  title: string;
  path?: string;
};

export interface BreadcrumbProps {
  links: Array<BreadcrumbLink>;
  separator: ReactNode | string;
  dataQaId: string;
}

const Breadcrumb: React.FC<BreadcrumbProps> = ({ links, separator, dataQaId }) => {
  const classes = useStyles();
  return (
    <Breadcrumbs classes={classes} separator={separator} aria-label="breadcrumbs" data-qa-id={dataQaId}>
      {links.map((link, idx) => (
        <Link
          key={idx}
          title={link.title}
          path={link.path}
          router={true}
          disableVisited={true}
          size="medium"
          dataQaId={`${dataQaId}-${link.title}`}
          selected={idx === links.length - 1}
        />
      ))}
    </Breadcrumbs>
  );
};

export default Breadcrumb;
